module.exports = __webpack_public_path__ + "images/spoticar3fd6d8ec3a8b8f13c58e418f680d69e2.png";